import { sprintf } from 'sprintf-js';

import { Avatar } from 'components/Avatar/Avatar';
import { Tooltip } from 'components/Tooltip/Tooltip';
import { useUserEnvironment } from 'contexts/UserEnvironmentContext';

export function CmsReactionsUserAvatar() {
  const { user } = useUserEnvironment();

  if (!user?.image) return null;

  return (
    <Tooltip
      variant="filled"
      content={sprintf(getText('Posting as %(name)s'), { name: user?.name })}
      placement="top-right"
      withArrow={false}
    >
      <div data-qa-id="cms-reactions-user-avatar">
        <Avatar
          image={user?.image}
          name={user?.name || getText('User')}
          size="xs"
        />
      </div>
    </Tooltip>
  );
}
